import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "value", "label", "fullWidth", "labelProps", "fieldProps", "containerProps", "onFocus", "name", "checked", "disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { StyledSwitch } from './switch.styles';
import { jsx as _jsx } from "react/jsx-runtime";
export var Switch = function Switch(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      label = _ref.label,
      fullWidth = _ref.fullWidth,
      labelProps = _ref.labelProps,
      fieldProps = _ref.fieldProps,
      containerProps = _ref.containerProps,
      onFocus = _ref.onFocus,
      name = _ref.name,
      checked = _ref.checked,
      disabled = _ref.disabled,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var inputName = name && "".concat(name, "-switch");
  return /*#__PURE__*/_jsx(StyledSwitch, _objectSpread({
    onChange: onChange,
    value: Boolean(value),
    id: inputName,
    checked: checked,
    onFocus: onFocus,
    disabled: disabled
  }, restProps));
};